import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import {Box, Typography} from '@mui/material';

import {type JobMatchCriterionDetail} from '../types/TalentPoolProfileTypes';

import {greenColors} from '../../../../../layouts/theme/designSystem';

type Props = {
  row: JobMatchCriterionDetail;
};

export const TalentPoolCriterionAnalysisRow = ({row}: Props) => {
  const showMet = row.met !== undefined;

  return (
    <Box sx={{py: 0.5}}>
      <Box sx={{display: 'flex', gap: 1, alignItems: 'flex-start'}}>
        {showMet ? (
          row.met ? (
            <CheckCircleOutlineIcon sx={{color: 'success.main', fontSize: 20, mt: 0.15, flexShrink: 0}} />
          ) : (
            <HighlightOffIcon sx={{color: 'error.main', fontSize: 20, mt: 0.15, flexShrink: 0}} />
          )
        ) : null}
        <Box sx={{flex: 1, minWidth: 0}}>
          <Typography variant='body2' fontWeight={600} sx={{color: greenColors[900]}}>
            {row.criterion}
          </Typography>
          {row.explanation ? (
            <Typography variant='body2' sx={{color: greenColors[100], mt: 0.5}}>
              {row.explanation}
            </Typography>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
};
